import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { getLatestMovies } from '@/mocks/movies';
import { getPosterUrl } from '@/mocks/imageUrls';

export default function LatestMoviesSection() {
  const movies = getLatestMovies(8);

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新电影
            </h2>
            <p className="text-foreground-500 text-sm mt-2">新片上映同步更新，高清画质流畅播放</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-primary-400 hover:text-primary-300 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {movies.map((movie) => (
            <MovieCard
              key={movie.id}
              {...movie}
              posterUrl={getPosterUrl(movie.posterSeq)}
            />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1 text-primary-400 hover:text-primary-300 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看全部电影
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}